export type CostCenterCustomer = {
  name: string;
  label: string;
  id: number;
};

export type CostCenterCreatedUser = {
  id: number;
  name: string;
};

export type CostCenterModifiedUser = {
  id: number | null;
  name: string | null;
};

export type ConstCenterRecord = {
  id: number;
  name: string;
  customer: CostCenterCustomer;
  note: string;
  createdAt: string;
  createdBy: CostCenterCreatedUser;
  modifiedAt: string | null;
  modifiedBy: CostCenterModifiedUser | null;
};

export const CostCenterTableSettingsKeys = {
  name: 'table_list.columns.name',
  customer: 'table_list.columns.customerId',
  note: 'table_list.columns.note',
  createdBy: 'table_list.columns.createdBy',
  createdAt: 'table_list.columns.createdAt',
  modifiedBy: 'table_list.columns.modifiedBy',
  modifiedAt: 'table_list.columns.modifiedAt',
};
